<template>
  <van-sku :style="{paddingBottom: tabHeight+'px'}" v-model="showSku" :close-on-click-overlay="true" :sku="sku" :goods="goods"
    :goods-id="goodsId" :quota="quota" :quota-used="quotaUsed" :hide-stock="sku.hide_stock"
    :reset-stepper-on-hide="true" :initial-sku="initialSku" :show-add-cart-btn="false" :start-sale-num="startSaleNum"
    buy-text="确定" @click="closeClick" @buy-clicked="sureClick" @sku-prop-selected="change" @sku-selected="skuChange">
    <!--    @close="closeClick"-->
    <!--    @add-cart="sureClick"-->
    <!--  >-->
  </van-sku>
</template>

<script>
import { Sku } from 'vant'

export default {
  props: { // type 底部确定按钮用途
    type: 0, // 0 购物车 修改规格  1 加入购物车 2 购买
    show: false,
    goodsInfo: {},
    cartInfo: {} // 购物车列表 单条数据信息
  },
  data () {
    return {
      tabHeight: 0,
      showSku: this.show,
      goodsId: this.goodsInfo.id,
      quotaUsed: 0,
      quota: 0,
      startSaleNum: 1, // 起购数量
      sku: {
        tree: [],
        // 所有 sku 的组合列表，比如红色、M 码为一个 sku 组合，红色、S 码为另一个组合
        list: [],
        // price: '1.00', // 默认价格（单位元）
        // stock_num: 227, // 商品总库存
        // collection_id: 2261, // 无规格商品 skuId 取 collection_id，否则取所选 sku 组合对应的 id
        none_sku: false, // 是否无规格商品
        hide_stock: false // 是否隐藏剩余库存
      },
      goods: {
        // 数据结构见下方文档
        picture: ''
      },
      initialSku: { // 默认选中sku
        selectedNum: 1
      },
      messageConfig: {
        // 数据结构见下方文档
      }
    }
  },
  methods: {
    skuChange (e) { // skuValue, selectedSku, selectedSkuComb
      console.log(e)
      this.startSaleNum = e.selectedSkuComb.startSaleNum
    },
    closeClick: function () {
      console.log('================close')
      this.showSku = false
    },
    sureClick: function (e) {
      console.log(e)
      let skuIndex = this.getSkuId(e.selectedSkuComb.id)
      let number = e.selectedNum
      this.showSku = false
      this.$emit('click', this.type, skuIndex, number)
    },
    getSkuId: function (id) { // 获取 所选sku 的下标
      var index = 0
      console.log(this.goodsInfo.detailList)
      // let array = this.goodsInfo.detailList
      for (let i = 0; i < this.goodsInfo.detailList.length; i++) {
        let info = this.goodsInfo.detailList[i]
        if (info.id === id) {
          index = i
        }
      }
      return index
    },
    setSelectView: function () {
      console.log(this.goodsInfo)
      // this.sku.initialSku.selectedNum = this.goodsInfo.detailList[0].min_order_num
      // 规格
      let specs = []
      for (let i = 0; i < this.goodsInfo.specs.length; i++) {
        let info = {
          id: 's' + i, // skuValueId：规格值 id
          name: this.goodsInfo.specs[i] // skuValueName：规格值名称
          // imgUrl: corverUrls[i], // 规格类目图片，只有第一个规格类目可以定义图片
          // previewImgUrl: corverUrl // 用于预览显示的规格类目图片
        }
        specs.push(info)
      }
      // 颜色
      let colors = []
      for (let i = 0; i < this.goodsInfo.colors.length; i++) {
        let info = {
          id: 's' + i, // skuValueId：规格值 id
          name: this.goodsInfo.colors[i] // skuValueName：规格值名称
          // imgUrl: corverUrl, // 规格类目图片，只有第一个规格类目可以定义图片
          // previewImgUrl: corverUrl // 用于预览显示的规格类目图片
        }
        colors.push(info)
      }
      var skuTree = []
      for (let i = 0; i < 2; i++) {
        let obj = {
          k: i === 0 ? '规格' : '颜色', // skuKeyName：规格类目名称
          k_s: i === 0 ? 's1' : 's2', // skuKeyStr：sku 组合列表（下方 list）中当前类目对应的 key 值，value 值会是从属于当前类目的一个规格值 id
          v: i === 0 ? specs : colors,
          largeImageMode: false //  是否展示大图模式
        }
        skuTree.push(obj)
      }
      this.sku.tree = skuTree

      var skuList = []
      for (let i = 0; i < specs.length; i++) {
        for (let j = 0; j < colors.length; j++) {
          let info = this.matchFormatter(this.goodsInfo.specs[i], this.goodsInfo.colors[j])
          var obj = {}
          if (info === null) {
            obj = {
              id: 0, // skuId
              s1: 's' + i, // 规格类目 k_s 为 s1 的对应规格值 id
              s2: 's' + j, // 规格类目 k_s 为 s2 的对应规格值 id
              price: 0, // 价格（单位分）
              stock_num: 0, // 当前 sku 组合对应的库存
              startSaleNum: 1 // 当前sku组合对应的最少购买数
            }
          } else {
            var cPrice = parseInt(info.original_price)
            if (info.discount_price !== undefined) {
              cPrice = parseInt(info.discount_price)
            }
            obj = {
              id: info.id, // skuId
              s1: 's' + i, // 规格类目 k_s 为 s1 的对应规格值 id
              s2: 's' + j, // 规格类目 k_s 为 s2 的对应规格值 id
              price: cPrice, // 价格（单位分）
              stock_num: info.inventory, // 当前 sku 组合对应的库存
              startSaleNum: info.min_order_num
            }
          }
          skuList.push(obj)
        }
      }
      this.sku.list = skuList

      // 价格 与库存
      let dGoodsInfo = this.goodsInfo.detailList[0]
      var dPrice = parseInt(dGoodsInfo.original_price)
      if (dGoodsInfo.discount_price !== undefined) {
        dPrice = parseInt(dGoodsInfo.discount_price)
      }
      this.sku.price = this.utils.keepPoint(dPrice / 100) //  // 默认价格（单位元）
      var stockNum = 0
      for (let i = 0; i < this.goodsInfo.detailList.length; i++) {
        let info = this.goodsInfo.detailList[i]
        stockNum += info.inventory
      }
      this.sku.stock_num = stockNum // 商品总库存
      // this.sku.collection_id = this.goodsInfo.id // 无规格商品 skuId 取 collection_id，否则取所选 sku 组合对应的 id
      this.sku.goods_id = this.goodsInfo.id
      this.sku.none_sku = false // 是否无规格商品
      this.sku.hide_stock = false // 是否隐藏剩余库存

      var corverUrl = this.goodsInfo.product_cover
      if (this.goodsInfo.product_cover.indexOf(',') >= 0) {
        corverUrl = this.goodsInfo.product_cover.split(',')[0]
      }
      this.goods.picture = corverUrl

      // 默认sku
      if (this.cartInfo === undefined) {
        return
      }
      if (this.cartInfo.id !== undefined) {
        console.log(this.cartInfo)
        var s1 = ''
        var s2 = ''
        let specDetail = JSON.parse(this.cartInfo.spec_detail)
        for (let i = 0; i < this.goodsInfo.specs.length; i++) {
          if (this.goodsInfo.specs[i] === specDetail['规格']) {
            s1 = 's' + i
          }
        }
        for (let i = 0; i < this.goodsInfo.colors.length; i++) {
          if (this.goodsInfo.colors[i] === specDetail['颜色']) {
            s2 = 's' + i
          }
        }
        let obj = {
          s1: s1,
          s2: s2,
          selectedNum: this.cartInfo.number
        }
        this.initialSku = obj
        console.log(this.initialSku)
      }
      console.log('cartInfo=====333333333')
    },
    matchFormatter: function (spec, color) {
      for (let i = 0; i < this.goodsInfo.detailList.length; i++) {
        let info = this.goodsInfo.detailList[i]
        if (info.spec_detail.indexOf(spec) >= 0 && info.spec_detail.indexOf(color) >= 0) {
          return info
        }
      }
      return null
    },
    androidTabHeight: function (value) {
      // 设置android 模态导航条
      if (this.utils.isIphone() === true) {
        if (this.utils.isIphoneX() === true) {
          this.tabHeight = 20
        } else {
          this.tabHeight = 0
        }
      } else {
        this.tabHeight = (value !== 'null' ? parseInt(value) : 0) 
      }
    }
  },
  watch: {
    show (val) {
      // console.log('val----------' + val)
      this.showSku = val
    },
    showSku (val) {
      // console.log('showSku----------' + val)
      if (val === false) {
        this.$emit('hideClick')
      }
    },
    goodsInfo (val) {
      if (this.goodsInfo.specs !== undefined) {
        this.setSelectView()
      }
    }
  },
  components: {
    Sku
  },
  mounted () {
    if (parseInt(this.$route.query.isApp) === 1 || parseInt(localStorage.getItem('isApp')) === 1 || parseInt(this.$route.query.isApp) === 2 || parseInt(localStorage.getItem('isApp')) === 2) {
      var _this = this
      window['androidTabHeight'] = (result) => {
        _this.androidTabHeight(result)
      }
      if (this.utils.isIphone() === true) {
        this.androidTabHeight('0')
      } else {
        this.androidTabHeight(window.zxzx.getNavigationBarHeight())
      }
    }
  }
}
</script>

<style scoped>
>>> .van-popup,
.van-popup--round,
.van-popup--bottom {
  border-radius: 0px 0px 0px 0px;
}
>>> .van-sku-header .van-sku-header__img-wrap {
  margin-top: -40px;
  width: 130px;
  height: 130px;
  /*margin: 12px 0;*/
  /*overflow: hidden;*/
  background: #f9f9f9;
  border-radius: 2px;
}
>>> .van-sku-header__img-wrap {
  position: relative;
  float: left;
  width: 96px;
  height: 96px;
  margin: 12px 0;
  overflow: hidden;
  background: #f7f8fa;
  border-radius: 4px;
}
>>> .van-sku-header__goods-info {
  padding: 12px 0px 12px 15px;
}
>>> .van-sku__price-symbol {
  font-size: 20px;
  color: #c41335;
}
>>> .van-sku__price-num {
  font-size: 20px;
  color: #c41335;
  line-height: 30px;
}
>>> .van-sku-actions .van-button--danger {
  background: -webkit-linear-gradient(left, #c41335, #c41335);
  background: linear-gradient(to right, #c41335, #c41335);
}
>>> .van-sku-actions .van-button:last-of-type {
  background-color: #c41335;
  border-radius: 4px;
  border-radius: 4px;
}
>>> .van-sku-row__item--active {
  color: #feeeee;
  border: solid 1px #c41335;
  box-sizing: border-box;
  border-radius: 2px;
  color: #c41335;
  /*pa*/
}
>>> .van-sku-row__item-name {
  padding: 5px 12px;
}
>>> .van-sku-row__title {
  color: #000000;
}
</style>



// WEBPACK FOOTER //
// src/view/shopping/goods/goods-select.vue